<template>
  <Container :list="this.$nav2" title="广信概况"  v-if="isMaxScreen">
    <div class="xxgk">
      <div class="breadcrumb">
        <router-link to="/" class="breadcrumb-item">
          首页
        </router-link>
        <!-- -
        <router-link to="/xxjj/xxgk?ids=0" class="breadcrumb-item">
          学校简介
        </router-link> -->
        -
        <span class="breadcrumb-item">广信概况</span>
      </div>
      <div class="content" v-html="home.content"></div>
    </div>
  </Container>

  <XxgkH5 v-else :home="home"/>
</template>

<script>
import Container from '@/components/Container/index'
import XxgkH5 from '@/views/app/xxgk/index'
export default {
  name: 'BianLi',
  components: { Container, XxgkH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      tit: '',
      home: {}
    }
  },
  watch: {

  },
  computed: {},

  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  created () {
    this.getDetail()
  },

  methods: {
    async getDetail () {
      const data = await this.$get('/ow/schoolintro')
      this.home = data
    }
  }
}
</script>

<style scoped lang="scss">
  .xxgk {
    .content{
      font-size: 16px;
      text-indent: 2em!important;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      ::v-deep p {
        line-height: 2;
      }
      ::v-deep img {
        max-width: 812px!important;
        object-fit: cover;
      }
    }
  }

</style>
